import React from 'react'
import { BannerItem } from './banner'
import ContactFormWrapper from './contact_form_wrapper'
import CardGallery from '../fragments/card-gallery'

const Marketing: React.FC<{ block: any }> = ({ block }) => {
  return (
    <section className={`block ${block._template}  ${block.css_class_name}`}>
      <div className="container">
        {block.position === 'Top' && <MarketingTop block={block} />}
        {block.position !== 'Top' && <MarketingBottom block={block} />}
      </div>
    </section>
  )
}

const MarketingTop: React.FC<{ block: any }> = ({ block }) => {
  const blockForm = block.form.length > 0 ? block.form[0] : null

  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <h1
          className="h1--reset"
          dangerouslySetInnerHTML={{ __html: block.title }}
        />
        <div className="block__banner block__banner--top">
          {block.items.map((item, index) => {
            return (
              <div key={`banner-mix-top-${index}`} className="banner--col">
                <BannerItem item={{ ...item, subtitle: null }} />
                <div className="banner__text-and-icon">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="text-and-icon__icon"
                  />
                  <p className="text-and-icon__text">{item.subtitle}</p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      {blockForm && (
        <div className="col-12 col-lg-6">
          <ContactFormWrapper block={blockForm} />
        </div>
      )}
    </div>
  )
}

const MarketingBottom: React.FC<{ block: any }> = ({ block }) => {
  const cardBlock = block.blocks.length > 0 ? block.blocks[0] : null;
    
  if (cardBlock) {
    cardBlock.css_class_name = cardBlock.settings
    ? cardBlock.settings.css_class_name
    : "";
    cardBlock.theme = "skinned";
  }

  const blockForm = block.form.length > 0 ? block.form[0] : null

  const titleId = block.title_id ? { id: block.title_id }: {};

  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <h1
          className="h1--reset h1--styled"
          dangerouslySetInnerHTML={{ __html: block.title }}
          {...titleId}
        />
        <p>{block.text}</p>
        <div className="block__banner block__banner--bottom">
          {block.items.map((item, index) => {
            return (
              <div key={`banner-mix-bottom-${index}`} className="banner--col">
                <div className="banner__text-and-icon">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="text-and-icon__icon"
                  />
                  <p
                    className="text-and-icon__text"
                    dangerouslySetInnerHTML={{ __html: item.subtitle }}
                  />
                </div>
              </div>
            )
          })}
        </div>
        {cardBlock && <CardGallery block={cardBlock} />}
      </div>
      {blockForm && (
        <div className="col-12 col-lg-6">
          <ContactFormWrapper block={blockForm} />
        </div>
      )}
    </div>
  )
}

export default Marketing
